import {ServiceRequestComment} from '../data.types';

export class ServiceRequest {
    public static fromExistingData(request: any): ServiceRequest {
        const serviceRequest = new ServiceRequest();
        if (request.building) serviceRequest.buildingId = +request.building.bdId;
        if (request.building) serviceRequest.buildingName = request.building.name;
        if (request.createdAt) serviceRequest.createdAt = request.createdAt;
        if (request.createdBy) serviceRequest.createdByFullName = request.createdBy.fullName;
        if (request.notes) serviceRequest.notes = request.notes;
        if (request.id) serviceRequest.id = request.id;
        if (request.description) serviceRequest.description = request.description;
        if (request.serviceRequestNumber) serviceRequest.serviceRequestNumber = request.serviceRequestNumber;
        if (request.serviceRequestType) serviceRequest.serviceRequestType = request.serviceRequestType;
        if (request.serviceRequestTypeOther) serviceRequest.serviceRequestTypeOther = request.serviceRequestTypeOther;
        if (request.otherResident) serviceRequest.otherResident = request.otherResident;
        if (request.otherSuite) serviceRequest.otherSuite = request.otherSuite;
        if (request.priority) serviceRequest.priority = request.priority;
        if (request.status) serviceRequest.status = request.status;
        if (request.isRead) serviceRequest.isRead = request.isRead;
        if (request.shareContact) serviceRequest.shareContact = request.shareContact;
        if (request.permissionToEnter) serviceRequest.permissionToEnter = request.permissionToEnter;
        if (request.resident) serviceRequest.residentId = +request.resident.bdId;
        if (request.resident) serviceRequest.residentFullName = request.resident.fullName;
        if (request.suite) serviceRequest.suiteId = +request.suite.bdId;
        if (request.suite) serviceRequest.suiteNumber = request.suite.suiteNumber;
        if (request.comments) serviceRequest.comments = request.comments;
        if (request.updatedAt) serviceRequest.updatedAt = request.updatedAt;
        if (request.serviceRequestWorkerContract) serviceRequest.serviceRequestWorkerContract = request.serviceRequestWorkerContract;
        if (request.serviceRequestWorkerContractOther) serviceRequest.serviceRequestWorkerContractOther = request.serviceRequestWorkerContractOther;
        if (request.attachments) serviceRequest.attachments = request.attachments;
        if (request.assigneeEmail) serviceRequest.assigneeEmail = request.assigneeEmail;
        if (request.assigneeName) serviceRequest.assigneeName = request.assigneeName;
        serviceRequest.isCanEdit = request.isCanEdit;
        serviceRequest.isCanDelete = request.isCanDelete;
        return serviceRequest;
    }
    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public description: string = '',
        public serviceRequestNumber: string = '',
        public serviceRequestType: string = '',
        public notes: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public serviceRequestTypeOther: string = '',
        public serviceRequestWorkerContract: string = '',
        public serviceRequestWorkerContractOther: string = '',
        public priority: string = '',
        public createdAt: string = '',
        public createdByFullName: string = '',
        public status: string = '',
        public assigneeEmail: string = '',
        public assigneeName: string = '',
        public isRead: boolean = false,
        public shareContact: boolean = false,
        public permissionToEnter: boolean = false,
        public comments: ServiceRequestComment[] = [],
        public formFields = {
            building: {editMode: false},
            unit: {editMode: false},
            resident: {editMode: false},
            shareContact: {editMode: false},
            permissionToEnter: {editMode: false},
            requestType: {editMode: false},
            priority: {editMode: false}
        },
        public updatedAt: string = '',
        public attachments: Array<any> = [],
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ServiceRequest.ts